import { EventEmitter, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IConfigLogin } from '../../interfaces/config-login.interface';

@Injectable({
  providedIn: 'root',
})
export class DataLoginService {
  dataLogin!: IConfigLogin;
  configData: any;
  private sendDataLoginSubject = new Subject<IConfigLogin>();
  sendLoginObservable = this.sendDataLoginSubject.asObservable();
  private configSubject = new Subject<any>();
  configObservable = this.configSubject.asObservable();

  constructor() {}

  saveData(data: IConfigLogin) {
    this.dataLogin = data;
    this.sendDataLoginSubject.next(this.dataLogin);
  }

  config(config: any) {
    this.configData = config;
    this.configSubject.next(config);
  }
  login() {
    return this.dataLogin;
  }

  getConfig() {
    return this.configData;
  }
}
